module.exports = __webpack_public_path__ + "img/service_4.337c513b.jpg";